import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';

import styles from './styles.module.scss';

export default function LoadingCells(props) {
    const { quantity, noMargin, minifiedPrice } = props;

    const calcArray = () => {
        let calcArray = [];

        for (let idx = 0; idx < quantity; idx++) {
            calcArray.push(idx);
        }

        return calcArray;
    }

    return (
        <div className={styles.cells}>
            {
                calcArray().map((idx) => {
                    return (
                        <div className={styles.cell} key={`cell_${idx}`} style={noMargin && { margin: 0 }}>
                            <Skeleton variant="rect" width={175} height={140} style={{borderRadius: '8px'}} />
                            <div className={styles.cellContent}>
                                <div className={styles.cellTitle}>
                                    <Skeleton variant="rect" width={'100%'} height={20} style={{marginBottom: '5px'}} />
                                    <Skeleton variant="rect" width={60} height={20} />
                                </div>
                                {
                                    minifiedPrice
                                    ? <div className={styles.cellPrice}>
                                        <Skeleton variant="rect" width={60} height={20} />
                                    </div>
                                    : <div className={styles.cellPrice}>
                                        <Skeleton variant="rect" width={80} height={24} style={{marginBottom: '5px'}} />
                                        <Skeleton variant="rect" width={50} height={16} />
                                    </div>
                                }
                            </div>
                        </div>  
                    )
                })
            }
        </div>
    )
}